import styled from 'styled-components';
import { getColor, makePercent } from 'core/utils';

export const Wrapper = styled.a`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	& + & {
		margin-top: 16px;
	}

	&:active, &:focus {
		text-decoration: none;
	}
`;

export const TextWrapper = styled.div`
	max-width: ${makePercent(80, 500)};
	flex-basis: ${makePercent(80, 500)};

	@media (max-width: 767px) {
		max-width: ${makePercent(50, 350)};
		flex-basis: ${makePercent(50, 350)};
	}
`;

export const Text = styled.span`
	display: block;
	text-align: ${props => props.right ? 'right' : 'left'};
	font-weight: 600;
	font-size: 14px;
	line-height: 14px;
	letter-spacing: 0.2px;
	color: ${getColor('dustyGray')};
	white-space: nowrap;

	@media (max-width: 767px) {
		font-size: 12px;
		line-height: 18px;
	}
`;

export const LineWrapper = styled.div`
	padding: 0 10px;
	max-width: ${makePercent(340, 500)};
	flex-basis: ${makePercent(340, 500)};
	margin: 0 auto;

	@media (max-width: 767px) {
		max-width: ${makePercent(250, 350)};
		flex-basis: ${makePercent(250, 350)};
	}

	svg {
		display: block;
		width: 100%;
	}
`;
